import { errorKeyForCode, type MessageKey } from "@/lib/i18n/error-messages"

/**
 * Failures the customer cannot retry from the overlay: the bag the backend
 * refused has to be rebuilt, and a closed channel will not accept the same
 * order however many times it is sent.
 */
const TERMINAL_FAILURE = /indisponível no momento|fechada agora/i

/** True when the only useful action left is going back to the menu. */
export function isTerminalCheckoutFailure(invalidOrder: boolean, message: string): boolean {
  return invalidOrder || TERMINAL_FAILURE.test(message)
}

/**
 * Rejections the customer fixes in the bag, not by sending the same order
 * again: an option group the merchant refused, or lines that no longer match
 * the catalog. Retrying resends the exact cart the backend just rejected.
 */
const BAG_FAILURE_KEYS = new Set<MessageKey>(["optionGroupInvalid", "staleCart"])

/** True when the failure asks the customer to review the bag before trying again. */
export function isBagCheckoutFailure(code: string | null | undefined): boolean {
  const key = errorKeyForCode(code)
  return key !== null && BAG_FAILURE_KEYS.has(key)
}

export type CheckoutConfirmation = {
  title: string
  message: string
}

/**
 * Copy of the confirmation screen. A scheduled order says WHEN it is scheduled
 * for, in the same words the review card used — telling the customer the store
 * will start preparing would be a promise for an order nobody is cooking yet.
 */
export function checkoutConfirmation(scheduledSummary: string | null): CheckoutConfirmation {
  if (!scheduledSummary) {
    return {
      title: "Pedido realizado!",
      message: "Tudo certo! A loja já recebeu seu pedido e vai começar o preparo.",
    }
  }
  return {
    title: "Pedido agendado!",
    message: `${scheduledSummary}. A loja recebeu seu pedido e começa o preparo na hora certa.`,
  }
}
